(() => {
  const carousels = document.querySelectorAll('[data-dp-carousel-viewport]');

  carousels.forEach((viewport) => {
    const section = viewport.closest('.dp-challenges');
    const controls = section?.querySelector('[data-dp-carousel-controls]');
    const cards = Array.from(viewport.children);
    const previous = controls?.querySelector('[data-dp-carousel-prev]');
    const next = controls?.querySelector('[data-dp-carousel-next]');
    const dots = controls ? Array.from(controls.querySelectorAll('[data-dp-carousel-dot]')) : [];

    if (!controls || !cards.length) return;

    let activeIndex = 0;
    let frame;
    let pointerStartX = 0;
    let pointerStartScroll = 0;
    let isDragging = false;

    const getActiveIndex = () => {
      const scrollLeft = viewport.scrollLeft;
      return cards.reduce((closest, card, index) => {
        const currentDistance = Math.abs(card.offsetLeft - scrollLeft);
        const closestDistance = Math.abs(cards[closest].offsetLeft - scrollLeft);
        return currentDistance < closestDistance ? index : closest;
      }, 0);
    };

    const updateControls = () => {
      activeIndex = getActiveIndex();
      dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      previous.disabled = activeIndex === 0;
      next.disabled = activeIndex === cards.length - 1;
    };

    const scrollToCard = (index) => {
      const targetIndex = Math.max(0, Math.min(index, cards.length - 1));
      viewport.scrollTo({ left: cards[targetIndex].offsetLeft, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollToCard(activeIndex - 1));
    next.addEventListener('click', () => scrollToCard(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => scrollToCard(index)));

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      isDragging = true;
      pointerStartX = event.clientX;
      pointerStartScroll = viewport.scrollLeft;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(event.pointerId);
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!isDragging) return;
      event.preventDefault();
      viewport.scrollLeft = pointerStartScroll - (event.clientX - pointerStartX);
    });
    const stopDragging = (event) => {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove('is-dragging');
      if (event.pointerId !== undefined && viewport.hasPointerCapture(event.pointerId)) {
        viewport.releasePointerCapture(event.pointerId);
      }
    };
    viewport.addEventListener('pointerup', stopDragging);
    viewport.addEventListener('pointercancel', stopDragging);
    viewport.addEventListener('lostpointercapture', stopDragging);
    viewport.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateControls);
    }, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  });
})();
